module.exports = __webpack_public_path__ + "img/img_67.45336738.png";